import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../pages/Login";

export default function AuthRoutes() {
    
    return (
        <Routes>
            <Route path="login" element={<Login />} />
            <Route path='/' element={<Navigate to={'login'} />} />

            <Route path='/*'element={ '404' } />
        </Routes>
    );
}